import { useNavigate } from "react-router-dom"

export default function Title({children, className, titleClassName, style, back}) {

    const navigate = useNavigate()

    const handleBack = () => {
        if (back) back()
        else navigate(-1)
    }    

    return(<div className={`flex gap-xs center ${className ?? ''}`}>
        <button className="icon" onClick={handleBack}>
            <span className="material-symbols-outlined">arrow_back_ios_new</span>
        </button>
        <p className={`v-spacer-xxs ${titleClassName ?? 'section-title'}`} style={style ?? {}}>{children}</p>
    </div>)
}